module.exports = __webpack_public_path__ + "static/img/clurlogo.65d678c1.png";